import { registerPlugin } from '@capacitor/core'

/**
 * Tiny in-app Capacitor plugin that opens the OS Settings page for our
 * app — used as the Android counterpart to iOS's `app-settings:` URL
 * scheme. The native implementation lives at
 * `android/app/src/main/java/com/digola/lingotalk/AppSettingsPlugin.java`
 * and fires `Settings.ACTION_APPLICATION_DETAILS_SETTINGS`.
 *
 * No native iOS implementation: `speech.ts::openAppSettings` uses the
 * iOS URL scheme directly. The `registerPlugin` call is lazy — it does
 * not throw on iOS even with no native side; calls only fail at invoke
 * time, which we never do under iOS.
 */
interface AppSettingsBridge {
  open(): Promise<void>
}

export const AppSettings = registerPlugin<AppSettingsBridge>('AppSettings')
